module.exports = __webpack_public_path__ + "img/iceskating005.d7617022.jpg";